const user = {
    state: {
        isLogin: false
    },
    mutations: {
        logout (state, vm) {
            $utils.data.clear('auth')
            // 恢复默认样式
            let themeLink = document.querySelector('link[name="theme"]');
            // themeLink.setAttribute('href', '');
            // 清空打开的页面等数据，但是保存主题数据
            let theme = '';
            if (localStorage.theme) {
                theme = localStorage.theme;
            }
            localStorage.clear();
            if (theme) {
                localStorage.theme = theme;
            }
        },
        updateLoginStatus(state,isLogin){
            state.isLogin=isLogin;
        }
    }
};

export default user;
